// 文件上传
function uploadFile(params) {
    if (!params.url || (!params.id && !params.files)){
        console.error('上传路径和id是必填的！')
        return
    }
    let formData = new FormData();
    let maxSize = params.maxSize * 1000 || 1024 * 1000
    let type = params.type
    let fileList
    if (params.id){
        fileList = document.getElementById(params.id).files
    }
    else if (params.files){
        fileList = params.files
    }
    if (!fileList[0]) {
        return
    }
    for (let k in params.data) {
        formData.append(k, params.data[k])
    }
    for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size > maxSize) {
            console.error('上传文件大小超了！')
            return
        }
        if (type) {
            let suffix = fileList[i].name.substr(fileList[i].name.lastIndexOf(".")+1)
            let result = new RegExp(suffix,'i').test(type)
            if (!result) {
                console.error('上传的文件格式不正确！')
                return
            }
        }
        formData.append('files', fileList[i]);
    }
    let xhr = new XMLHttpRequest();
    xhr.open('post', params.url);
    xhr.setRequestHeader('access-key', params.token);
    xhr.send(formData);
    xhr.addEventListener("error", uploadFailed, false);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
            let res = xhr.responseText
            params.success && params.success(res)
        }
        else {
            let res = xhr.responseText
            params.error && params.error(res)
        }
    };
    function uploadFailed(evt) {
        params.error && params.error(evt)
    }
}

export default uploadFile
